import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '../ui/button';

function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return false;
  const header = document.querySelector('header');
  const headerH = header ? header.offsetHeight : 0;
  const top = el.getBoundingClientRect().top + window.scrollY - headerH - 12;
  window.scrollTo({ top, behavior: 'smooth' });
  return true;
}

export default function CtaBlock({ title, subtitle, ctaLabel = 'Get Started Now', ctaTo = '/loan' }) {
  const location = useLocation();

  let hashId = '';
  let pathPart = ctaTo || '';
  if (typeof ctaTo === 'string' && ctaTo.includes('#')) {
    const [p, h] = ctaTo.split('#');
    pathPart = p; hashId = h;
  }
  const isSamePageHash = hashId && (pathPart === '' || pathPart === location.pathname);

  const handleClick = (e) => {
    if (!isSamePageHash) return;
    e.preventDefault();
    if (!scrollToId(hashId)) requestAnimationFrame(() => scrollToId(hashId));
  };

  const ButtonEl = (
    <Button className="bg-emerald-600 hover:bg-emerald-500 text-white h-12 px-7 text-base shadow-lg">{ctaLabel}</Button>
  );

  return (
    <section className="py-16 lg:py-20 bg-white">
      <div className="max-w-6xl mx-auto px-5 lg:px-8">
        <div className="rounded-3xl bg-gradient-to-br from-slate-900 to-slate-800 relative overflow-hidden">
          <div className="absolute inset-0 grid-pattern opacity-30" />
          <div className="absolute -top-10 -right-10 w-64 h-64 rounded-full bg-emerald-500/20 blur-3xl" />
          <div className="relative px-8 py-14 lg:py-16 lg:px-14 grid lg:grid-cols-3 gap-6 items-center">
            <div className="lg:col-span-2">
              <h3 className="font-serif-display text-3xl lg:text-4xl text-white font-bold">{title}</h3>
              {subtitle && <p className="mt-3 text-slate-300">{subtitle}</p>}
            </div>
            <div className="lg:justify-self-end">
              {isSamePageHash ? (
                <a href={`#${hashId}`} onClick={handleClick}>{ButtonEl}</a>
              ) : (
                <Link to={ctaTo}>{ButtonEl}</Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
